// extracted by mini-css-extract-plugin
export default {"bodyWrapper":"bodyWrapper-qWmX7","button":"button-p_vhW"};